var render, staticRenderFns
import script from "./dir.vue?vue&type=script&lang=js&"
export * from "./dir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5cdb448f', component.options)
    } else {
      api.reload('5cdb448f', component.options)
    }
    
  }
}
component.options.__file = "src/components/form_element/dir.vue"
export default component.exports